// ##########################################################################################
// JDA gallery module
// ==========================================================================================
// Previously a large and complex module, this has been made more managable
// by modularisation. Note the subModules object literal below. Each property of this variable
// houses a cluster of functions and values that relate to specific responsibilities.
// Each submodule may communicate with another submodule, or this master gallery module
// directly, without the need to send mediator messages. The pattern that has been
// established is intended only to group related functionality together, and not to facilitate
// the seamless addition of and removal of other submodules. However, for the sake of
// organisation and comprehensibility, all of the conditionals and high level logic that
// describe when to run a subroutine should exist within
// this 'gallery.js' master module wherever possible.
// ##########################################################################################

app.mediator.registerModule(MODULE_NAME__GALLERY, function (app) {

	// ##########################################################################################
	// Data
	// ##########################################################################################

    var helpers = app.helpers.funcs;

	var $rootElem = null;

	var subModules = {
		appendManager: null,
		dataManager: null,
		entryBlockManager: null,
        revealManager: null,
        scrollCacher: null,
	};

	var selectorClasses = {
		buildAnimation: 'full-page-build-animation',
        restoringPosition: 'restoring-position',
        allShown: 'all-shown',
        entryBlock: 'featured-block',
        activeEntryBlock: 'active',
        backToTopBtn: 'back-to-top-btn',
        backToTopBtnActive: 'is-showing',
	};

	// ##########################################################################################
	// Bootstrapping
	// ##########################################################################################

	function onLoaded(data) {
        if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
            initIfSubmodulesHaveLoaded();
        }
    }

	function injectSubModule(moduleKey, moduleFn) {
		subModules[moduleKey] = moduleFn();
	}

    function getSubModule(moduleKey) {
        return subModules[moduleKey];
    }

    function initIfSubmodulesHaveLoaded() {
		var allLoaded = Object.keys(subModules).every(function(subModuleKey) {
			if (subModules[subModuleKey] !== null) return true;
		});
		if (allLoaded) init();
    }

	function init() {

		$rootElem = $('.mod-gallery');
		if ($rootElem.length) {
			if (hasInfiniteScroll()) {
                addDomListenersForInfiniteScroll();
				app.mediator.notify(EVENT_NAME__GALLERY__GALLERY_WITH_INFINITE_SCROLL_INITIATED);
			}
            addDomListeners();
            addMediatorListeners();
            app.mediator.notify(EVENT_NAME__GALLERY__GALLERY_INITIATED);
		}

        // Delete stored scroll position in response to mediator event coming from the core content module,
        // regardless of whether or not a gallery module element exists on the page too.
        app.mediator.addListener(EVENT_NAME__CORE_CONTENT__USER_LINGERD_ON_NON_PROJECT_PAGE, function() {
            subModules.scrollCacher.purge();
        });
	}

    // The code within this function is responsible for loading, appending and revealing award entries
    // when the page initially loads. It has been segregated from the init() function above, as the init()
    // function above triggers an event, which a script in the view file listens for, which then injects
    // entry data into the gallery. We only want to subsequently then reveal items after all of this has happened.
    function runInitialPageLoad() {

        var cachedScrollData = subModules.scrollCacher.pull();

        if (hasInfiniteScroll()) {

			if (cachedScrollData && cachedScrollData.url == window.location.pathname) {

				// Massage data
	            var cachedScrollPosition = parseInt(cachedScrollData.scrollPosition);
	            var cachedItemIdx = parseInt(cachedScrollData.itemIdx);

				// Set wrapper div min height, so we can be sure that we can scroll down at least that far.
                // Then, do the scrolling action.
	            $rootElem.css('min-height', (cachedScrollPosition + 800) + 'px');
                window.scrollTo(0, cachedScrollPosition);

                // Do the fetch, append, and reveal - but only if the gallery filters module has finished firing up first.
                // We need to wait for this, the gallery filters module broadcasts its current filter state when
                // its init function runs.
                app.mediator.awaitOnce(EVENT_NAME__GALLERY_FILTERS__NEW_FILTER_DATA_APPLIED, function(data) {

                    // The 'restoring position class' is the 'hook' that the CSS styles
                    // for a viewport-centred loading spinner are hung onto.
                    // These styles let the user see the spinner, regardless of how far
                    // down they are scrolled.
                    subModules.revealManager.addRestoringPositionClass();

	        	    // Modify last-used filters DTO: Populate it with the filters that were being used
                    // the last time the user was on this page. We also want to ensure that all of the award entries
                    // that were visible before will be fetched in one go now so that they are all visible.
                    // (See: modifyFiltersDto({...skip: 0});
	                var numberOfItemsToLoadFromServer = sanitiseLoadNumber(cachedItemIdx + (cachedItemIdx % 2 ? 5 : 4));
                    subModules.dataManager.setFiltersDto(cachedScrollData.currentFilterData);
                    subModules.dataManager.updateFiltersDtoSearchText(cachedScrollData.currentFilterData.text);
	                subModules.dataManager.modifyFiltersDto({
	                    take: numberOfItemsToLoadFromServer,
	                    skip: 0
	                });

                    // Notify other modules that filter data was retored.
                    var restoredFilterData = subModules.dataManager.getFiltersDto();
                    app.mediator.notify(EVENT_NAME__GALLERY__FILTER_DATA_RESTORED, {
                        restoredFilterData: restoredFilterData
                    });

                    getEntriesAppendEntriesRevealEntriesThen(function() {

                        // Once entries have been fetched and appended,
                        // remove the 'restoring position CSS class, reveal all entries above the fold,
                        // and remove the min-height constraint. (In case the user filters again,
                        // and a smaller amount of entries are returned).
                        subModules.revealManager.removeRestoringPositionClass();
                        subModules.revealManager.revealAllAboveFold();
                        $rootElem.css('min-height', '');

                    }, numberOfItemsToLoadFromServer);
                });

            } else {
                subModules.revealManager.temporarilyAddBuildAnimationClass();
                subModules.appendManager.appendMoreItems();
                subModules.revealManager.revealAllAboveFold();
            }

        } else {
            subModules.revealManager.temporarilyAddBuildAnimationClass();
            subModules.appendManager.appendMoreItems();
            subModules.revealManager.revealAll();
        }
    }

    function deinit() {

    }

    // A macro function that will contact the server, get a bunch of entries,
    // populate the DOM with them, and reveal the ones above the fold.
    // You may specify a callback function, which will be invoked when the roundtrip to the
    // server has completed, and (optionally) a number to fetch, append and reveal.
    function getEntriesAppendEntriesRevealEntriesThen(cb, numberToGet) {

        numberToGet = sanitiseLoadNumber(numberToGet);

        // Clear down past entry blocks from display and from memory
        subModules.dataManager.clearEntriesData();
        subModules.appendManager.removeAll();
        showLoadMask();

        // Adjust the data manager dto to get more than just one batch of entries
        // from the server. We want it to load all entries up to the stored scroll position.
        if (numberToGet) subModules.dataManager.modifyFiltersDto({ take: numberToGet });

        subModules.dataManager.fetchEntriesAndSpliceThen(function(newEntries) {

            // Add new entry blocks to the DOM and reveal them. Hide the loading mask.
            if (numberToGet === null) {
                subModules.appendManager.appendMoreItems();
            } else {
                subModules.appendManager.appendXItems(numberToGet);
            }

            // Finish client side display updates
            subModules.revealManager.temporarilyAddBuildAnimationClass();
            subModules.revealManager.revealAllAboveFold();
            hideLoadMask();

            // Run callback
            if (typeof cb === 'function') cb(newEntries);

            // Triggering the scroll event programatically after a short delay
            // ensures that the events which conditionally show the footer are invoked.
            setTimeout(function() {
                $(window).trigger('scroll');
            }, 100);

            // Restore original number of items to fetch per time.
            subModules.dataManager.modifyFiltersDto({ take: subModules.dataManager.getNumberPerLoad() }, false);

            // Show the 'No entries' message if applicable.
            var numberOfEntriesInMemory = subModules.dataManager.getEntriesData().length;
            if (numberOfEntriesInMemory >= 1) {
                onSomeItemsShown();
            } else {
                onNoItemsShown();
            }
        });
    }

	function addDomListeners() {

        var $rootElem = getRootElem();
        var entryBlockSelector = getSelectorClass('entryBlock');

        // We only want the subroutines contained in the function below to run at most every 200ms.
        // Imposing this limit will preserve memory and keep everything running smoothly.
        var throttledOnResize = helpers.throttler(function () {
            subModules.entryBlockManager.adjustAllBlocks();
        }, 50);

        app.globalEventRegistry.addListener('resize', function () {
            throttledOnResize();
        });
        $rootElem.on('mouseenter focus', '.' + entryBlockSelector, function () {
            if (helpers.getScreenSize() !== app.helpers.screenBreakpoints.xs) {
                subModules.entryBlockManager.showDescriptionForBlock($(this).find('.descr'));
            }
        });
        $rootElem.on('mouseleave blur', '.' + entryBlockSelector, function () {
            if (helpers.getScreenSize() !== app.helpers.screenBreakpoints.xs) {
                subModules.entryBlockManager.hideDescriptionForBlock($(this).find('.descr'));
            }
        });
	}

	function addDomListenersForInfiniteScroll() {

        // We only want the subroutines contained in the function below to run at most every 200ms.
        // Imposing this limit will preserve memory and keep everything running smoothly.
        var throttledOnScroll = helpers.throttler(function () {

            subModules.revealManager.revealAllAboveFold();
                
            var shouldLoadMoreNow = (function() {

                if (subModules.dataManager.hasFetchedAllEntries()) return false;
                if (subModules.dataManager.hasFetchesPending()) return false;

                var userIsCloseToEndOfCurrentResults = (function() {
                    var numberOfEntriesInMemory = subModules.dataManager.getEntriesData().length;
                    var numberOfEntriesDisplayed = subModules.revealManager.getNumberOfRevealedBlocks();
                    var numberOfItemsInMemoryLeftToDisplay = numberOfEntriesInMemory - numberOfEntriesDisplayed;
                    var numberPerAjaxFetch = subModules.dataManager.getNumberPerLoad();
                    return (numberOfItemsInMemoryLeftToDisplay < parseInt(numberPerAjaxFetch / 2));
                }());

                if (!userIsCloseToEndOfCurrentResults) return false;

                return true;
            }());

            if (shouldLoadMoreNow) {
                subModules.dataManager.fetchEntriesAndSpliceThen(function(newEntries) {
                    subModules.appendManager.appendMoreItems();
                    subModules.revealManager.revealAllAboveFold();
                });
            } else {
                subModules.revealManager.onRevealComplete();
            }

            adjustBackToTopButtonVisibility();

        }, 200);

        var throttledOnResize = helpers.throttler(function () {
            subModules.revealManager.revealAllAboveFold();
            adjustBackToTopButtonVisibility();
        }, 200);

        app.globalEventRegistry.addListener('scroll', function () {
            throttledOnScroll();
        });
        app.globalEventRegistry.addListener('resize', function () {
            throttledOnResize();
        });

        var scrollCacher = galleryModule.getSubModule('scrollCacher');
        getRootElem().on('click', '.' + getSelectorClass('entryBlock'), function (e, data) {
            e.preventDefault();
            var itemPositionInGallery = $(this).prevAll().length;
            var linkUrl = $(this).attr('href');
            scrollCacher.purge();
            scrollCacher.store(itemPositionInGallery);
            window.location.href = linkUrl;
        });

        $rootElem.on('click', '.' + getSelectorClass('backToTopBtn'), function(e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 250);
        });
	}

	function addMediatorListeners() {

        app.mediator.addListener(EVENT_NAME__GALLERY_FILTERS__NEW_FILTER_DATA_APPLIED, function(data) {

            if (subModules.dataManager.hasFetchesPending()) {
                subModules.dataManager.abortFetch();
            }

            subModules.dataManager.setFiltersDto(data.filterData);
            if (data.filterDataUpdateDueTo !== 'initialLoad') {
                getEntriesAppendEntriesRevealEntriesThen();
            }
        });

        app.mediator.addListener(EVENT_NAME__GALLERY_TITLE_BAR__NEW_FILTER_DATA_APPLIED, function(data) {

            // Let the data manager know that the gallery title bar search input box has a new value.
            // (The data manager will then take a note of this value, and store it within itself).
            subModules.dataManager.updateFiltersDtoSearchText(data.filterData.searchTerm);

            // ...and do another fetch, append and reveal, but ONLY IF the 'new filter data applied' event
            // wasn't the result of cached filters being restored from a cached value.
            // We don't want to run search and append calls in response to this. Search and append calls are triggered
            // by other events (Filter button applied press, scroll down event), and collisions / multiple appendings /
            // incorrectly ordered function calls will happen if initiated by a 'filter restore' event too.
            if (data.broadcastingDueTo !== 'filterRestore') {
                if (subModules.dataManager.hasFetchesPending()) {
                    subModules.dataManager.abortFetch();
                }
                getEntriesAppendEntriesRevealEntriesThen();
            }
        });
	}

	// ##########################################################################################
	// Event callbacks
	// ##########################################################################################

    function onAllItemsShown() {
        $rootElem.addClass(selectorClasses.allShown);
        app.mediator.notify(EVENT_NAME__GALLERY__BOTTOM_OF_INFINITE_SCROLL_REACHED);
    }

    function onSomeItemsShown() {
        hideNoItemsMessage();
    }

    function onNoItemsShown() {
        showNoItemsMessage();
    }

    function onAjaxAbort() {
        hideLoadMask();
    }

	// ##########################################################################################
	// Scroll to top button functionality
	// ##########################################################################################

    function adjustBackToTopButtonVisibility() {
        if (
            (!hasInfiniteScroll()) ||
            (!getRootElem().find('.' + getSelectorClass('entryBlock')).length)
        ) {
            return;
        }
        var galleryOffset = getRootElem().offset().top;
        var scrollOffset = $(window).scrollTop();
        var windowHeight = $(window).height();
        if (scrollOffset + (windowHeight / 2) > galleryOffset) {
            showBackToTopButton();
        } else {
            hideBackToTopButton();
        }
    }

    function showBackToTopButton() {
        getRootElem().find('.' + getSelectorClass('backToTopBtn')).addClass(getSelectorClass('backToTopBtnActive'));
    }

    function hideBackToTopButton() {
        getRootElem().find('.' + getSelectorClass('backToTopBtn')).removeClass(getSelectorClass('backToTopBtnActive'));
    }

	// ##########################################################################################
	// Main functions
	// ##########################################################################################

    function getRootElem() {
        return $rootElem;
    }

    function getSelectorClass(selectorKey) {
        if (!selectorClasses[selectorKey]) throw 'Could not get a selector with a key of: ' + selectorKey;
        return selectorClasses[selectorKey];
    }

    function showLoadMask() {
        helpers.addLoadMaskTo($rootElem);
    }

    function hideLoadMask() {
        helpers.removeLoadMaskFrom($rootElem);
    }

    function showNoItemsMessage() {
        $rootElem.find('.mod-gallery-no-items').ariaShow();
    }

    function hideNoItemsMessage() {
        $rootElem.find('.mod-gallery-no-items').ariaHide();
    }

    function hasInfiniteScroll() {
        return $rootElem.hasClass('has-infinite-scroll');
    }

    // Ensures that the number of items we are trying to load / append / reveal
    // is never less than the amount specified in the append manager.
    function sanitiseLoadNumber(numberToGet) {
        numberToGet = typeof numberToGet !== 'undefined' ? numberToGet : 0;
        var appendNumberOfItemsPerLoad = subModules.appendManager.getNumberOfItemsPerLoad();
        return Math.max(numberToGet, appendNumberOfItemsPerLoad);
    }

	// ##########################################################################################
	// Public API
	// ##########################################################################################

	return {
		injectSubModule: injectSubModule,
        getSubModule: getSubModule,
        getSelectorClass: getSelectorClass,
        onLoaded: onLoaded,
        onAllItemsShown: onAllItemsShown,
        onAjaxAbort: onAjaxAbort,
        runInitialPageLoad: runInitialPageLoad,
		init: init,
		deinit: deinit,
        showLoadMask: showLoadMask,
        hideLoadMask: hideLoadMask,
        getRootElem: getRootElem
	};
});